{
  "GENERAL_SETTINGS": {
    "LIMIT_MESSAGES": {
      "CONVERSATION": "Превишихте лимита за разговори. Hacker планът позволява само 500 разговора.",
      "INBOXES": "Превишихте лимита за кутии. Hacker планът поддържа само уеб чат на живо. Допълнителни кутии като имейл, WhatsApp и т.н. изискват платен план.",
      "AGENTS": "Превишихте лимита за оператори. Hacker планът позволява само 2 оператора.",
      "NON_ADMIN": "Моля, свържете се с вашия администратор, за да надстрои плана и да продължи да използва всички функции."
    },
    "TITLE": "Account settings",
    "SUBMIT": "Update settings",
    "BACK": "Back",
    "DISMISS": "Dismiss",
    "UPDATE": {
      "ERROR": "Could not update settings, try again!",
      "SUCCESS": "Successfully updated account settings"
    },
    "ACCOUNT_DELETE_SECTION": {
      "TITLE": "Изтриване на вашия акаунт",
      "NOTE": "След като изтриете акаунта си, всички ваши данни ще бъдат изтрити.",
      "BUTTON_TEXT": "Изтрий вашия акаунт",
      "CONFIRM": {
        "TITLE": "Изтриване на акаунт",
        "MESSAGE": "Изтриването на вашия акаунт е необратимо. Въведете името на акаунта по-долу, за да потвърдите, че искате да го изтриете окончателно.",
        "BUTTON_TEXT": "Изтрий",
        "DISMISS": "Отказ",
        "PLACE_HOLDER": "Моля, напишете {accountName} за потвърждение"
      },
      "SUCCESS": "Акаунтът е маркиран за изтриване",
      "FAILURE": "Акаунтът не може да бъде изтрит, опитайте отново!",
      "SCHEDULED_DELETION": {
        "TITLE": "Акаунтът е планиран за изтриване",
        "MESSAGE_MANUAL": "Този акаунт е планиран за изтриване на {deletionDate}. Това е поискано от администратор. Можете да отмените изтриването преди тази дата.",
        "MESSAGE_INACTIVITY": "Този акаунт е планиран за изтриване на {deletionDate} поради неактивност. Можете да отмените изтриването преди тази дата.",
        "CLEAR_BUTTON": "Отмени планираното изтриване"
      }
    },
    "FORM": {
      "ERROR": "Please fix form errors",
      "GENERAL_SECTION": {
        "TITLE": "General settings",
        "NOTE": ""
      },
      "ACCOUNT_ID": {
        "TITLE": "Account ID",
        "NOTE": "This ID is required if you are building an API based integration"
      },
      "NAME": {
        "LABEL": "Account name",
        "PLACEHOLDER": "Your account name",
        "ERROR": "Please enter a valid account name"
      },
      "LANGUAGE": {
        "LABEL": "Site language",
        "PLACEHOLDER": "Your account name",
        "ERROR": ""
      },
      "DOMAIN": {
        "LABEL": "Incoming Email Domain",
        "PLACEHOLDER": "The domain where you will receive the emails",
        "ERROR": ""
      },
      "SUPPORT_EMAIL": {
        "LABEL": "Support Email",
        "PLACEHOLDER": "Your company's support email",
        "ERROR": ""
      },
      "AUTO_RESOLVE_DURATION": {
        "LABEL": "Number of days after a ticket should auto resolve if there is no activity",
        "NOTE": "Брой часове неактивност, след които всеки отворен разговор ще бъде автоматично разрешен.",
        "PLACEHOLDER": "30",
        "ERROR": "Please enter a valid auto resolve duration (minimum 1 day and maximum 999 days)"
      },
      "AUTO_RESOLVE_EMPTY_DURATION": {
        "LABEL": "Брой дни, след които празен разговор да се разреши автоматично, ако няма активност",
        "PLACEHOLDER": "никога",
        "ERROR": "Моля, въведете валидна продължителност (минимум 1 ден и максимум 999 дни)"
      },
      "FEATURES": {
        "INBOUND_EMAIL_ENABLED": "Conversation continuity with emails is enabled for your account.",
        "CUSTOM_EMAIL_DOMAIN_ENABLED": "You can receive emails in your custom domain now."
      },
      "PHONE": {
        "TITLE": "Настройки на PBX",
        "NOTE": "Конфигурирайте връзката с вашата PBX за телефонни обаждания",
        "SIP_HOST": {
          "LABEL": "SIP домейн"
        },
        "DIALING_MODE": {
          "LABEL": "Режим на набиране",
          "MODES": {
            "direct": "Директен - обаждането се набира веднага при кликване върху телефонна връзка",
            "indirect": "Непрям - телефонният номер се подготвя в полето на телефонния изтеглен модул"
          }
        },
        "CALL_RECORDING_ACCESS": {
          "LABEL": "Достъп до записи на обаждания",
          "MODES": {
            "admin_only": "Само администратори",
            "admin_and_assigned_agent": "Администратори и присвоения оператор",
            "inbox_members": "Всички оператори с достъп до кутията"
          }
        }
      },
      "EMAIL": {
        "TITLE": "Настройки на имейл",
        "NOTE": "Променя поведението на имейл кутиите"
      },
      "CONVERSATION_TIMESTAMP_DISPLAY_MODE": {
        "LABEL": "Режим на показване на времевата маркировка на разговора",
        "MODES": {
          "both": "Създадено и последна активност",
          "last_activity_only": "Само последна активност",
          "last_customer_message": "Последно съобщение от клиент"
        }
      },
      "BLOCK_DOMAINS_WITH_LOW_REPUTATION": {
        "LABEL": "Блокиране на домейни с ниска репутация"
      },
      "INCLUDE_PREVIOUS_EMAIL_MESSAGE": {
        "LABEL": "Включи оригиналното съобщение в отговора на имейла"
      },
      "RESOLVE_NEW_CONVERSATION": {
        "LABEL": "Автоматично разрешавай нов разговор"
      },
      "MOVE_CONVERSATIONS_BY_ORDERS": {
        "LABEL": "Автоматично премествай нов имейл разговор във входящата кутия на робота, който е обработил поръчките на контакта"
      },
      "EXTENDED_LABELS": {
        "LABEL": "Разширени етикети - Разрешава по-дълги имена на етикети с по-голям popup интерфейс"
      },
      "ENABLE_LAST_AGENT": {
        "LABEL": "LastAgent - Автоматично присвояване на разговор на оператора, който е създал последния отговор"
      },
      "PUSH_NOTIFICATION_MODE": {
        "LABEL": "Режим на push известия",
        "MODES": {
          "all_inboxes": "Всички кутии - Изпращай известия за всички типове канали",
          "chat_only": "Само чат - Изпращай известия само за не-имейл канали"
        }
      },
      "ALLOW_TOGGLE_SIGNATURE": {
        "LABEL": "Разреши превключване на подпис в изпратените съобщения"
      },
      "WALLBOARD_CHAT_STATUS_ENABLED": {
        "LABEL": "Показване на чат статуса на оператора на таблото"
      },
      "SHOW_FULL_ATTACHMENT_NAMES": {
        "LABEL": "Показвай пълните имена на прикачените файлове без съкращаване"
      },
      "PASSWORD_LOGIN_MODE": {
        "LABEL": "Вход с парола",
        "MODES": {
          "allowed_for_all": "Разрешено за всички потребители",
          "allowed_for_agents_only": "Разрешено само за оператори (администраторите трябва да използват OAuth)",
          "password_login_disabled": "Изключено - само OAuth"
        }
      }
    },
    "NEW_VERSION_AVAILABLE": "Налична е нова версия. Презаредете, за да получите последните обновления.",
    "RELOAD_NOW": "Обнови сега",
    "LEARN_MORE": "Learn more",
    "PAYMENT_PENDING": "Плащането ви очаква обработка. Моля, актуализирайте платежната си информация, за да продължите да използвате този софтуер",
    "LIMITS_UPGRADE": "Акаунтът ви надхвърли лимитите за използване. Моля, надградете плана си, за да продължите да използвате този софтуер",
    "OPEN_BILLING": "Open billing"
  },
  "FORMS": {
    "MULTISELECT": {
      "ENTER_TO_SELECT": "Press enter to select",
      "ENTER_TO_REMOVE": "Press enter to remove",
      "NO_OPTIONS": "Списъкът е празен",
      "NO_RESULT": "Няма намерени резултати",
      "SELECT_ONE": "Select one",
      "SELECT": "Изберете"
    }
  },
  "NOTIFICATIONS_PAGE": {
    "HEADER": "Notifications",
    "MARK_ALL_DONE": "Mark All Done",
    "DELETE_TITLE": "deleted",
    "UNREAD_NOTIFICATION": {
      "TITLE": "Unread Notifications",
      "ALL_NOTIFICATIONS": "View all notifications",
      "LOADING_UNREAD_MESSAGE": "Loading unread notifications...",
      "EMPTY_MESSAGE": "You have no unread notifications"
    },
    "LIST": {
      "LOADING_MESSAGE": "Loading notifications...",
      "404": "No Notifications",
      "TABLE_HEADER": [
        "Име",
        "Phone Number",
        "Разговори",
        "Last Contacted"
      ]
    },
    "TYPE_LABEL": {
      "conversation_creation": "New conversation",
      "conversation_assignment": "Conversation Assigned",
      "assigned_conversation_new_message": "New Message",
      "participating_conversation_new_message": "New Message",
      "conversation_mention": "Mention",
      "sla_missed_first_response": "SLA Missed",
      "sla_missed_next_response": "SLA Missed",
      "sla_missed_resolution": "SLA Missed"
    }
  },
  "NETWORK": {
    "NOTIFICATION": {
      "OFFLINE": "Offline",
      "RECONNECTING": "Reconnecting...",
      "RECONNECT_SUCCESS": "Reconnected"
    },
    "BUTTON": {
      "REFRESH": "Refresh"
    },
    "CONNECTION_LOST": {
      "TITLE": "Връзката е изгубена",
      "DESCRIPTION": "Не успяхме да се свържем със сървъра. Проверете връзката си и опитайте отново.",
      "RETRY": "Опитайте отново"
    }
  },
  "COMMAND_BAR": {
    "SEARCH_PLACEHOLDER": "Search or jump to",
    "SECTIONS": {
      "GENERAL": "General",
      "REPORTS": "Reports",
      "CONVERSATION": "Разговор",
      "BULK_ACTIONS": "Bulk Actions",
      "CHANGE_ASSIGNEE": "Change Assignee",
      "CHANGE_PRIORITY": "Change Priority",
      "CHANGE_TEAM": "Change Team",
      "SNOOZE_CONVERSATION": "Snooze Conversation",
      "EXECUTE_MACRO": "Изпълни макрос",
      "ADD_LABEL": "Add label to the conversation",
      "REMOVE_LABEL": "Remove label from the conversation",
      "SETTINGS": "Settings",
      "AI_ASSIST": "AI Assist",
      "APPEARANCE": "Appearance",
      "SNOOZE_NOTIFICATION": "Snooze Notification"
    },
    "COMMANDS": {
      "GO_TO_CONVERSATION_DASHBOARD": "Go to Conversation Dashboard",
      "GO_TO_CONTACTS_DASHBOARD": "Go to Contacts Dashboard",
      "GO_TO_REPORTS_OVERVIEW": "Go to Reports Overview",
      "GO_TO_CONVERSATION_REPORTS": "Go to Conversation Reports",
      "GO_TO_AGENT_REPORTS": "Go to Agent Reports",
      "GO_TO_LABEL_REPORTS": "Go to Label Reports",
      "GO_TO_INBOX_REPORTS": "Go to Inbox Reports",
      "GO_TO_TEAM_REPORTS": "Go to Team Reports",
      "GO_TO_SETTINGS_AGENTS": "Go to Agent Settings",
      "GO_TO_SETTINGS_TEAMS": "Go to Team Settings",
      "GO_TO_SETTINGS_INBOXES": "Go to Inbox Settings",
      "GO_TO_SETTINGS_LABELS": "Go to Label Settings",
      "GO_TO_SETTINGS_CANNED_RESPONSES": "Go to Canned Response Settings",
      "GO_TO_SETTINGS_APPLICATIONS": "Go to Application Settings",
      "GO_TO_SETTINGS_ACCOUNT": "Go to Account Settings",
      "GO_TO_SETTINGS_PROFILE": "Go to Profile Settings",
      "GO_TO_NOTIFICATIONS": "Go to Notifications",
      "ADD_LABELS_TO_CONVERSATION": "Add label to the conversation",
      "ASSIGN_AN_AGENT": "Assign an agent",
      "AI_ASSIST": "AI Assist",
      "ASSIGN_PRIORITY": "Assign priority",
      "ASSIGN_A_TEAM": "Assign a team",
      "EXECUTE_A_MACRO": "Изпълни макрос",
      "MUTE_CONVERSATION": "Mute conversation",
      "UNMUTE_CONVERSATION": "Unmute conversation",
      "REMOVE_LABEL_FROM_CONVERSATION": "Remove label from the conversation",
      "REOPEN_CONVERSATION": "Reopen conversation",
      "RESOLVE_CONVERSATION": "Resolve conversation",
      "SEND_TRANSCRIPT": "Send an email transcript",
      "SNOOZE_CONVERSATION": "Snooze Conversation",
      "UNTIL_NEXT_REPLY": "Until next reply",
      "UNTIL_NEXT_WEEK": "Until next week",
      "UNTIL_TOMORROW": "Until tomorrow",
      "UNTIL_NEXT_MONTH": "Until next month",
      "AN_HOUR_FROM_NOW": "Until an hour from now",
      "UNTIL_CUSTOM_TIME": "Custom...",
      "CHANGE_APPEARANCE": "Change Appearance",
      "LIGHT_MODE": "Light",
      "DARK_MODE": "Dark",
      "SYSTEM_MODE": "System",
      "SNOOZE_NOTIFICATION": "Snooze Notification"
    }
  },
  "DASHBOARD_APPS": {
    "LOADING_MESSAGE": "Loading Dashboard App..."
  },
  "COMMON": {
    "OR": "Or",
    "CLICK_HERE": "click here"
  }
}
